import {EntitaOrganizzativa} from '../../+anagrafica/entitaorganizzativa/entitaorganizzativa.model';
import {TipoEntitaOrganizzativa} from '../../+configurazione/tipoentitaorganizzativa/tipoentitaorganizzativa.model';
import {Gerarchia} from '../../+anagrafica/gerarchia/gerarchia.model';
import {TipoGerarchia} from '../../+configurazione/tipogerarchia/tipogerarchia.model';
import {Ruolo} from '../../+configurazione/ruolo/ruolo.model';
import {Genere} from '../../+anagrafica/persona/genere.enum';
import {Persona} from '../../+anagrafica/persona/persona.model';
import {RuoloUtente} from '../../+configurazione/ruoloutente/ruoloutente.model';
import {Cruscotto} from '../../+configurazione/cruscotto/cruscotto.model';
import {PersonaEntitaOrganizzativa} from '../../+anagrafica/personaentitaorganizzativa/personaentitaorganizzativa.model';
import {FasciaEntitaOrganizzativa} from '../../+anagrafica/fasciaentitaorganizzativa/fasciaentitaorganizzativa.model';
import {TipoAppartenenza} from '../../+anagrafica/personaentitaorganizzativa/tiporelazione.enum';
import {TipoEntitaLocale} from '../../+configurazione/tipoentitalocale/tipoentitalocale.model';
import {EntitaLocale} from '../../+anagrafica/entitalocale/entitalocale.model';
import {Indirizzo} from '../../+anagrafica/entitalocale/indirizzo.model';
import {IndirizzoEntitaLocale} from '../../+anagrafica/entitalocale/indirizzoentitalocale.model';
import {GeoIndirizzo} from '../../+geo/geoindirizzo/geo-indirizzo.model';
import {GeoCap} from '../../+geo/geocap/geo-cap.model';
import {Stradario} from '../../+geo/stradario/stradario.model';
import {GeoComune} from '../../+geo/geocomune/geo-comune.model';
import {GeoProvincia} from '../../+geo/geocomune/geo-provincia.model';
import {TipoContratto} from '../../+anagrafica/persona/tipocontratto.enum';
import {CategoriaGerarchia} from '../../+configurazione/tipogerarchia/categoria-gerarchia.enum';
import {Contesto} from '../../+configurazione/contesto/contesto.model';
import {TipoGerarchiaStruttura} from '../../+configurazione/tipogerarchiastruttura/tipogerarchiastruttura.model';
import {Utente} from '../../+configurazione/utente/utente.model';
import {RuoloPersona} from '../../+anagrafica/ruolopersona/ruolopersona.model';
import {GeoNazione} from '../../+geo/geonazione/geo-nazione.model';
import {
  TipoEntitaOrganizzativaAttributo
} from '../../+configurazione/tipoentitaorganizzativa/tipoentitaorganizzativaattributo/tipoentitaorganizzativaattributo.model';
import {TipoAttributo} from '../model/tipoattributo.enum';
import {
  TipoEntitaOrganizzativaAttributoValore
} from '../../+configurazione/tipoentitaorganizzativa/tipoentitaorganizzativaattributovalore/tipoentitaorganizzativaattributovalore.model';
import {Carattere} from '../../+anagrafica/entitaorganizzativa/carattere.enum';
import {CategoriaTipiEo} from '../../+configurazione/categoriatipieo/categoriatipieo.model';
import {Delega} from '../../+anagrafica/delega/delega.model';
import {TipoRuolo} from '../../+configurazione/ruolo/tipo-ruolo.enum';
import { SiperRecapito } from '../../+siper/siperrecapito/siper-recapito.model';
import { Fascia } from '../../+configurazione/fascia/fascia.model';
import { TipoAttributoEntity } from '../model/tipoattributoentity.model';
import { AttributoEntity } from '../model/attributoentity.model';
import { StatoRuoloPersona } from '../../+anagrafica/ruolopersona/statoruolopersona.enum';

export class JsonBaseBuilder {

  private static jsonRequirements(json) {
    if (json === null || json === undefined) {
      throw new TypeError('Json non presente');
    }
  }

  public static jsonToEntitaLocale(json): EntitaLocale {

    JsonBaseBuilder.jsonRequirements(json);

    const entitaOrganizzative: EntitaOrganizzativa[] = json.entitaOrganizzative.map( item => {
      return JsonBaseBuilder.jsonToEntitaOrganizzativa(item);
    });

    const indirizziEntitaLocale: IndirizzoEntitaLocale[] = json.indirizziEntitaLocale.map( item => {
      return JsonBaseBuilder.jsonToIndirizzoEntitaLocale(item);
    });

    return new EntitaLocale(json.id,
      json.descr,
      JsonBaseBuilder.jsonToTipoEntitaLocale(json.tipo),
      json.sedeDisagiata,
      json.codiceIstat,
      json.inizioValidita,
      json.fineValidita,
      indirizziEntitaLocale,
      entitaOrganizzative
    );
  }

  public static jsonToIndirizzoEntitaLocale(json): IndirizzoEntitaLocale {
    JsonBaseBuilder.jsonRequirements(json);

    return new IndirizzoEntitaLocale(json.id,
      json.principale,
      JsonBaseBuilder.jsonToIndirizzo(json.indirizzo));
  }

  public static jsonToIndirizzo(json): Indirizzo {
    JsonBaseBuilder.jsonRequirements(json);
    return new Indirizzo(json.id,
      json.via,
      json.civico,
      json.localita,
      json.comune,
      json.siglaProvincia,
      json.provincia,
      json.nazione,
      json.cap,
      json.geoId);
  }

  public static jsonToEntitaOrganizzativa(json): EntitaOrganizzativa {
    JsonBaseBuilder.jsonRequirements(json);

    let indirizzoPrincipale = null;
    if (json.indirizzoPrincipale) {
      indirizzoPrincipale = JsonBaseBuilder.jsonToIndirizzo(json.indirizzoPrincipale);
    }
    let fasceAppartenenza = null;
    if (json.fasceAppartenenza) {
      fasceAppartenenza = json.fasceAppartenenza.map(item => {
        return JsonBaseBuilder.jsonToFasciaEntitaOrganizzativa2(item);
      });
    }

    return new EntitaOrganizzativa(json.id,
      json.denominazione,
      json.denominazioneBreve,
      json.sigla,
      json.idnsip,
      json.cdsuo,
      json.inizioValidita,
      json.fineValidita,
      json.carattere ? new Carattere(json.carattere) : null,
      JsonBaseBuilder.jsonToTipoEntitaOrganizzativa(json.tipo),
      indirizzoPrincipale,
      json.entitaLocale,
      json.email,
      json.pec,
      json.sitoweb,
      json.telefono,
      json.telefono2,
      json.telefono3,
      json.fax,
      json.sedeRiferimento,
      json.valoreAttributoWebDtos,
      fasceAppartenenza,
      null
    );
  }

  public static jsonToTipoEntitaOrganizzativa(json): TipoEntitaOrganizzativa {
    JsonBaseBuilder.jsonRequirements(json);
    return new TipoEntitaOrganizzativa(json.id,
      json.descr,
      json.sigla,
      json.colore,
      json.categorie,
      json.inizioValidita,
      json.fineValidita,
      json.fasciaRequired);
  }

  public static jsonToRuolo(json: any): Ruolo {
    JsonBaseBuilder.jsonRequirements(json);
    let contestiVisualizzatore = null;
    if (json.contestiVisualizzatore) {
      contestiVisualizzatore = json.contestiVisualizzatore.map(item => {
        return JsonBaseBuilder.jsonToContesto(item);
      });
    }
    let tipiEntitaOrganizzativa = null;
    if (json.tipiEntitaOrganizzativa) {
      tipiEntitaOrganizzativa = json.tipiEntitaOrganizzativa.map(item => {
        return JsonBaseBuilder.jsonToTipoEntitaOrganizzativa(item);
      });
    }
    let ruoliAssociati = null;
    if (json.ruoliAssociati) {
      ruoliAssociati = json.ruoliAssociati.map(item => {
        return JsonBaseBuilder.jsonToRuolo(item);
      });
    }
    let ruoliGruppoAssociati = null;
    if (json.ruoliGruppoAssociati) {
      ruoliGruppoAssociati = json.ruoliGruppoAssociati.map(item => {
        return JsonBaseBuilder.jsonToRuolo(item);
      });
    }
    let ruoliAssegnati = null;
    if (json.ruoliAssegnati) {
      ruoliAssegnati = json.ruoliAssegnati.map(item => {
        return JsonBaseBuilder.jsonToRuolo(item);
      });
    }
    let ruoliGruppoAssegnati = null;
    if (json.ruoliGruppoAssegnati) {
      ruoliGruppoAssegnati = json.ruoliGruppoAssegnati.map(item => {
        return JsonBaseBuilder.jsonToRuolo(item);
      });
    }

    return new Ruolo(json.id, 
      json.descr, 
      json.sigla,
      json.padre, 
      json.assegnabileGlobalmente, 
      json.indennita, 
      json.soal, 
      JsonBaseBuilder.jsonToContesto(json.contesto),
      json.tipoRuolo ? new TipoRuolo(json.tipoRuolo) : null,
      contestiVisualizzatore, 
      tipiEntitaOrganizzativa,
      ruoliAssociati,
      ruoliGruppoAssociati,
      ruoliAssegnati,
      ruoliGruppoAssegnati);
  }

  public static jsonToTipoEntitaLocale(json): TipoEntitaLocale {
    JsonBaseBuilder.jsonRequirements(json);
    return new TipoEntitaLocale(json.id,
      json.descr);
  }

  public static jsonToTipoGerarchia(json): TipoGerarchia {
    JsonBaseBuilder.jsonRequirements(json);
    return new TipoGerarchia(json.id,
      json.descr,
      json.sigla,
      json.categoria ? new CategoriaGerarchia(json.categoria) : null,
      json.utilizzo);
  }

  public static jsonToGerarchia(json): Gerarchia {
    JsonBaseBuilder.jsonRequirements(json);
    return new Gerarchia(json.id,
      json.figlioGuida,
      json.padre ? JsonBaseBuilder.jsonToEntitaOrganizzativa(json.padre) : null,
      JsonBaseBuilder.jsonToEntitaOrganizzativa(json.figlio),
      JsonBaseBuilder.jsonToTipoGerarchia(json.tipo),
      json.inizioValidita,
      json.fineValidita);
  }

  public static jsonToCategoriaTipiEo(json: any): CategoriaTipiEo {
    JsonBaseBuilder.jsonRequirements(json);
    let tipiEntitaOrganizzativa = null;
    if (json.tipi) {
      tipiEntitaOrganizzativa = json.tipi.map(item => {
        return JsonBaseBuilder.jsonToTipoEntitaOrganizzativa(item);
      });
    }
    return new CategoriaTipiEo(json.id, json.descr, json.sigla, tipiEntitaOrganizzativa);
  }

  public static jsonToContesto(json: any): Contesto {
    JsonBaseBuilder.jsonRequirements(json);
    return new Contesto(json.id, json.descr, json.sigla, json.indennita, json.ruoliGenerici, json.ruoliGestore, json.ruoliManager, json.ruoliVisualizzati);
  }

  public static jsonToTipoGerarchiaStruttura(json: any): TipoGerarchiaStruttura {
    let padre = null;
    if (json.padre) {
      padre = JsonBaseBuilder.jsonToTipoEntitaOrganizzativa(json.padre);
    }
    return new TipoGerarchiaStruttura(json.id,
      JsonBaseBuilder.jsonToTipoGerarchia(json.tipoGerarchia),
      padre,
      JsonBaseBuilder.jsonToTipoEntitaOrganizzativa(json.figlio),
      json.modifica,
      json.ordine);
  }

  public static jsonToPersona(json: any): Persona {
    JsonBaseBuilder.jsonRequirements(json);

    let sede = null;
    if (json.sede) {
      sede = JsonBaseBuilder.jsonToEntitaOrganizzativa(json.sede);
    }

    return new Persona(json.id,
      json.nome,
      json.cognome,
      json.matricola,
      json.sesso ? new Genere(json.sesso) : null,
      json.dataNascita ? new Date(json.dataNascita) : null,
      json.codiceFiscale,
      json.username,
      json.utente,
      json.dataCessazione ? new Date(json.dataCessazione) : null,
      json.dataPrevistaCessazione ? new Date(json.dataPrevistaCessazione) : null,
      json.tipoContratto ? new TipoContratto(json.tipoContratto) : null,
      json.contratto,
      json.livello,
      json.profilo,
      json.livelloProfilo,
      json.dipendente,
      sede,
      null,
      json.valoreAttributoWebDtos,
      json.telefonoUfficio);
  }

  public static jsonToUtente(json: any): Utente {
    JsonBaseBuilder.jsonRequirements(json);

    let persona = null;
    if (json.persona) {
      persona = JsonBaseBuilder.jsonToPersona(json.persona);
    }

    return new Utente(json.id,
      json.username,
      json.email,
      json.scadAccount ? new Date(json.scadAccount) : null,
      json.ultimoAccesso ? new Date(json.ultimoAccesso) : null,
      json.indirizzoUltimoAccesso,
      json.inattivo,
      persona);
  }


  public static jsonToRuoloUtente(json: any): RuoloUtente {

    JsonBaseBuilder.jsonRequirements(json);

    let entitaOrganizzativa = null;
    if (json.entitaOrganizzativa) {
      entitaOrganizzativa = JsonBaseBuilder.jsonToEntitaOrganizzativa(json.entitaOrganizzativa);
    }

    return new RuoloUtente(json.id,
      JsonBaseBuilder.jsonToUtente(json.utente),
      JsonBaseBuilder.jsonToRuolo(json.ruolo),
      entitaOrganizzativa,
      json.note,
      json.provvedimento,
      json.attivo,
      json.delega,
      json.inizioValidita,
      json.fineValidita,
      json.indennita,
      json.importoIndennita,
      json.soal);
  }
  
  public static jsonToCruscotto(json: any): Cruscotto {

    JsonBaseBuilder.jsonRequirements(json);

    let entitaOrganizzativa = null;
    if (json.entitaOrganizzativa) {
      entitaOrganizzativa = JsonBaseBuilder.jsonToEntitaOrganizzativa(json.entitaOrganizzativa);
    }

    return new Cruscotto(json.id,
      JsonBaseBuilder.jsonToUtente(json.utente),
      JsonBaseBuilder.jsonToRuolo(json.ruolo),
      entitaOrganizzativa,
      json.inizioValidita,
      json.fineValidita);
  }

  public static jsonToRuoloPersona(json: any): RuoloPersona {
    JsonBaseBuilder.jsonRequirements(json);

    let entitaOrganizzativa = null;
    if (json.entitaOrganizzativa) {
      entitaOrganizzativa = JsonBaseBuilder.jsonToEntitaOrganizzativa(json.entitaOrganizzativa);
    }

    let personaDelegante = null;
    if (json.ruoloUtenteDelegante) {
      personaDelegante = JsonBaseBuilder.jsonToPersona(json.ruoloUtenteDelegante.utente.persona);
    }

    return new RuoloPersona(json.id,
      JsonBaseBuilder.jsonToPersona(json.utente.persona),
      JsonBaseBuilder.jsonToRuolo(json.ruolo),
      entitaOrganizzativa,
      json.note,
      json.provvedimento,
      json.inizioValidita,
      json.fineValidita,
      personaDelegante,
      json.delega,
      json.indennita,
      json.importoIndennita, 
      json.soal,
      new StatoRuoloPersona(json.stato),
      json.dataConsolidamento
      );
  }

  public static jsonToDelega(json: any): Delega {

    JsonBaseBuilder.jsonRequirements(json);

    let entitaOrganizzativa = null;
    if (json.entitaOrganizzativa) {
      entitaOrganizzativa = JsonBaseBuilder.jsonToEntitaOrganizzativa(json.entitaOrganizzativa);
    }

    return new Delega(json.id,
      JsonBaseBuilder.jsonToUtente(json.utente),
      JsonBaseBuilder.jsonToRuolo(json.ruolo),
      entitaOrganizzativa,
      json.note,
      json.provvedimento,
      json.attivo,
      json.delega,
      json.inizioValidita,
      json.fineValidita,
      json.indennita,
      json.importoIndennita,
      json.soal,
      json.ruoloUtenteDelegante,
      json.ruoloEntitaOrganizzativaDelegante);
  }

  public static jsonToPersonaEntitaOrganizzativa(json: any): PersonaEntitaOrganizzativa {
    JsonBaseBuilder.jsonRequirements(json);
    return new PersonaEntitaOrganizzativa(json.id,
      JsonBaseBuilder.jsonToPersona(json.persona),
      JsonBaseBuilder.jsonToEntitaOrganizzativa(json.entitaOrganizzativa),
      json.note,
      json.provvedimento,
      json.tipoAppartenenza ? new TipoAppartenenza(json.tipoAppartenenza) : null,
      json.inizioValidita,
      json.fineValidita);
  }

  /**
   * Il geo indirizzo viene restituito nel caso di utilizzo della select2 che ispeziona sia stradario che indirizzi.
   * @param json
   * @returns {Stradario | GeoIndirizzo}
   */
  public static jsonToStradario(json): Stradario | GeoIndirizzo {

    console.log(json);
    JsonBaseBuilder.jsonRequirements(json);

    if (json.via) {
      return JsonBaseBuilder.jsonToGeoIndirizzo(json);
    }

    return new Stradario(
      json.id,
      json.provincia,
      json.comune,
      json.codiceComune,
      json.localita,
      json.dug,
      json.denominazione
    );
  }

  public static jsonToGeoCap(json): GeoCap {
    JsonBaseBuilder.jsonRequirements(json);

    return new GeoCap(
      json.id,
      json.cap,
      json.comune ? JsonBaseBuilder.jsonToGeoComune(json.comune) : null
    );
  }

  public static jsonToGeoNazione(json): GeoNazione {
    JsonBaseBuilder.jsonRequirements(json);

    return new GeoNazione(
      json.id,
      json.denominazione
    );
  }


  public static jsonToGeoIndirizzo(json): GeoIndirizzo {

    JsonBaseBuilder.jsonRequirements(json);
    return new GeoIndirizzo(
      json.id,
      json.via,
      json.civico,
      json.localita,
      JsonBaseBuilder.jsonToGeoComune(json.comune),
      json.cap ? JsonBaseBuilder.jsonToGeoCap(json.cap) : null,
    );
  }

  public static jsonToGeoComune(json): GeoComune {

    JsonBaseBuilder.jsonRequirements(json);

    return new GeoComune(json.id,
      json.denominazione,
      json.codiceIstat,
      json.provincia ? JsonBaseBuilder.jsonToGeoProvincia(json.provincia) : null,
      json.nazione ? JsonBaseBuilder.jsonToGeoNazione(json.nazione) : null,
    );
  }

  public static jsonToGeoProvincia(json): GeoProvincia {

    JsonBaseBuilder.jsonRequirements(json);

    return new GeoProvincia(json.id,
      json.denominazione,
      json.sigla);
  }

  public static jsonToTipoEntitaOrganizzativaAttributo(json): TipoEntitaOrganizzativaAttributo {

    JsonBaseBuilder.jsonRequirements(json);
    return new TipoEntitaOrganizzativaAttributo(json.id,
      json.nome,
      json.tipo ? new TipoAttributo(json.tipo) : null);
  }

  public static jsonToTipoEntitaOrganizzativaAttributoValore(json): TipoEntitaOrganizzativaAttributoValore {

    JsonBaseBuilder.jsonRequirements(json);
    return new TipoEntitaOrganizzativaAttributoValore(json.id,
      json.target,
      JsonBaseBuilder.jsonToTipoEntitaOrganizzativaAttributo(json.attributo),
      json.valore);
  }

  public static jsonToSiperRecapito(json): SiperRecapito {

    JsonBaseBuilder.jsonRequirements(json);
    return new SiperRecapito(json.id,
      json.provincia,
      json.comune,
      json.indirizzo,
      json.cap,
      json.statoId,
      json.telefono,
      json.cellulare,
      json.email);
  }

  public static jsonToFascia(json: any): Fascia {
    JsonBaseBuilder.jsonRequirements(json);
    return new Fascia(json.id, 
      json.descr, 
      json.sigla,
      json.importoIndennita);
  }

  public static jsonToTipoAttributo(json: any): TipoAttributoEntity {
    JsonBaseBuilder.jsonRequirements(json);
    return new TipoAttributoEntity(
      json.id, 
      json.nome, 
      json.descr,
      json.tipodati
    );
  }

  public static jsonToAttributo(json: any): AttributoEntity {
    JsonBaseBuilder.jsonRequirements(json);
    return new AttributoEntity(
      json.id, 
      json.nome, 
      JsonBaseBuilder.jsonToTipoAttributo(json.tipoAttributo),
      json.entitaNome,
      json.multiplo,
      json.descr
    );
  }

  public static jsonToFasciaEntitaOrganizzativa(json: any): FasciaEntitaOrganizzativa {
    JsonBaseBuilder.jsonRequirements(json);
    return new FasciaEntitaOrganizzativa(json.id,
      JsonBaseBuilder.jsonToFascia(json.fascia),
      JsonBaseBuilder.jsonToEntitaOrganizzativa(json.entitaOrganizzativa),
      json.inizioValidita,
      json.fineValidita);
  }

  public static jsonToFasciaEntitaOrganizzativa2(json: any): FasciaEntitaOrganizzativa {
    JsonBaseBuilder.jsonRequirements(json);
    return new FasciaEntitaOrganizzativa(json.id,
      JsonBaseBuilder.jsonToFascia(json.fascia),
      json.entitaOrganizzativa,
      json.inizioValidita,
      json.fineValidita);
  }
}
